import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class ConnectAction extends BasicEntity {
code: string;
description: TranslatedEmb;
icon: string;
label: TranslatedEmb;
parameters: Object;
processCode: string;
processMode: string;
resultAction: string;
resultError: TranslatedEmb;
resultSuccess: TranslatedEmb;
scope: string;
useWarning: boolean | null;
warnDetail: TranslatedEmb;
warnTitle: TranslatedEmb;
}

